import React, { Component } from "react";
import {
	View,
	Modal,
	Image,
	TouchableOpacity,
	Text,
	TextInput,
	ActivityIndicator,
	ScrollView,
} from "react-native";
import Font from "react-font";
import Fade from "react-reveal/Fade";
import { APP_COLOURS } from "../APP_VARS";

export default class CellNumber extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showPolicy: false,
		};
	}

	render() {
		let w = this.props.screenWidth;
		let h = this.props.screenHeight;
		let doc = [
			"The Protection of Personal Information Act, 2013 (“POPI”) came into complete commencement on 1 July 2021, in this regard we have a number of obligations and duties in terms of POPI that we must comply with. The protection of your personal information is a high priority for us and we have taken steps to ensure that your personal information is protected and remains private.",
			`In addition to this document serving as our privacy policy, this document will also serve as our data subject notification as contemplated in section 18 of POPI. In this regard, this document will inform you of what personal information we collect, why we collect it, how we use it and what safety measures are in place to protect it.
			Where we refer to “process”, it means how we collect, use, store, make available, destroy, update, disclose, or otherwise deal with your personal information. As a general rule we will only process your personal information if this is required to deliver or offer a service, provide a product or carry out a transaction.
			We may combine your personal information and use the combined personal information for any of the purposes stated in this Privacy Policy.
			In this document any reference to “we” or “us” or “our” is reference to Revlon South Africa (Pty) Ltd.
			If you use our services, goods and/or products, you agree that we may process your personal information as explained under this Privacy Policy.
			We may change this Privacy Policy from time to time if the law or our business practices requires it.
			The version of the Privacy Policy displayed on our website at the time of your interaction with us will be applicable.
			`,
			`What is personal information?
			Personal information refers to any information that identifies you or specifically relates to you. Personal information includes, but is not limited to, the following information about you:
			Age Belief Birth Biometric Colour
			Financial history Gender
			Identity number Language
			Location information
			Personal views Physical address Physical health Pregnancy
			Race
			Conscience Correspondence Criminal history Culture
			Disability
			Education
			E-mail address Employment history Ethnic origin
			Marital Status Mental Health Medical History Name
			National Origin
			Online identifier
			Other particular assignment Personal opinions
			Personal preferences
			Religion
			Sex
			Sexual orientation Social origin Symbol
			Telephone number Well being`,
			`Is the supply of the personal information voluntary or mandatory?
			The supply of certain personal information is mandatory, meaning we have to collect this personal information from you by law. If you do not supply this information, we cannot comply with our legal obligations. In this regard, if you do not supply this personal information we cannot do business with you. We collect personal information as is required by the following legislation:
			`,
			`Basic Conditions of Employment Act, No 75 of 1997
			Continuing Education and Training Act (previously known as Further Education and Training
			Colleges Act) 16 of 2006
			Compensation for Occupational Injuries and Diseases Act, No. 130 of 1993 Credit Agreement Act, No. 75 of 1980
			The Criminal Procedure Act, No. 51 of 1977
			Debt Collectors Act, No. 114 of 1998
			Employment Equity Act, No. 55 of 1998
			Financial Intelligence Centre Act, No. 38 of 2001
			Higher Education Act 101 of 1997
			Income Tax Act 58 of 1962
			Labour Relations Act, No 66 of 1995
			National Credit Act, No. 34 of 2005
			NQF Act No 67 of 2008
			Pension Funds Act, No. 24 of 1956
			Skills Development Act 97 of 1998
			Unemployment Insurance Act, No. 63 of 2001
			Financial Advisory and Intermediary Service Act, No. 37 of 2002 Occupational Health and Safety Act No. 85 of 1993
			Prevention of Organised Crime Act No. 121 of 1998`,
			`In other instances the supply of personal information is voluntary, which means there is no law imposed on us to collect this personal information. Even though there is no law that
			imposes the collection of the personal information, we require the personal information to deliver the products and/or services to you. In this regard, if you do not supply the personal information, we cannot do business with you.`,
			`When will we process your personal information?
			We will only process your personal information for lawful purposes relating to our business if the following applies:
			• if you have consented thereto.
			• if a person legally authorised by you, the law, or a court, has consented thereto.
			• if it is necessary to conclude or perform under a contract, we have with you.
			• if the law requires or permits it.
			• if it is required to protect or pursue your, our or a third party’s legitimate interest.`,
			`What is special personal information?
			Special personal information is personal information about the following:
			Biometric information Criminal behaviour Ethnic origin
			Health
			Philosophical beliefs Sex life
			Political persuasion Trade union membership Race
			Religious beliefs`,
			`When will we process your special personal information?
			We may process your special personal information in the following circumstances:
			• if you have consented to the processing.
			• if the information is being used for any Human resource or payroll requirement.
			• if the processing is needed to create, use, or protect a right or obligation in law.
			• if the processing is for statistical or research purposes and all legal conditions are met.
			• if the special personal information was made public by you.
			• if the processing is required by law.
			• if racial information is processed, and the processing is required to identify you; and /
			or if health information is processed, and the processing is to determine your insurance risk, or to comply with an insurance policy or to enforce an insurance right or obligation.`,
			`When and from where we obtain personal information about you?
			We may collect personal information about you from the following sources:
			• We may collect personal information directly from you.
			• We may collect personal information from a public record.
			• We may collect personal information from an area where you have deliberately made
			it public.
			• We may collect information about you based on your use of our products, services, or
			service channels.
			• We may collect information about you based on how you engage or interact with us such as via our support desk, emails, letters, telephone calls and surveys.
			• We may collect personal information from a third party.
			• We may collect personal information from another source if you give us consent to do
			so.`,
			`If the law requires us to do so, we will ask for your consent before collecting personal information about you from third parties.
			The third parties from whom we may collect your personal information include, but are not limited to, the following:
			• Partners of our company for any of the purposes identified in this Privacy Policy.
			• your spouse, dependents, partners, employer, and other similar sources.
			• attorneys, tracing agents, debt collectors and other persons that assist with the
			enforcement of agreements.
			• payment processing services providers, merchants, banks, and other persons that
			assist with the processing of your payment instructions, like EFT transaction partners.
			• insurers, brokers, other financial institutions, or other organisations that assist with insurance and assurance underwriting, the providing of insurance and assurance policies and products, the assessment of insurance and assurance claims and other
			related purposes.
			• law enforcement and fraud prevention agencies and other persons tasked with the prevention and prosecution of crime;
			• regulatory authorities, industry ombudsman, governmental departments, local and international tax authorities.
			• trustees, Executors or Curators appointed by a court of law.
			• our service providers, agents and sub-contractors like couriers and other persons we
			use to offer and provide products and services to you.
			• courts of law or tribunals.
			`,
			`Reasons we need to process your personal information.
			We will process your personal information for the following reasons:
			• to provide you with products, goods, and services
			• to market our products, goods, and services to you.
			• to respond to your enquiries and complaints.
			• to comply with legislative, regulatory, risk and compliance requirements (including directives, sanctions, and rules), voluntary and involuntary codes of conduct and industry agreements or to fulfil reporting requirements and information requests.
			• to conduct market and behavioural research, including scoring and analysis to determine if you qualify for products and services or to determine your credit or insurance risk.
			• to develop, test and improve products and services for you.
			• for historical, statistical and research purposes, like market segmentation.
			• to process payment instruments.
			• to create, manufacture and print payment issues (like a payslip)
			• to enable us to deliver goods, documents, or notices to you.
			• for security, identity verification and to check the accuracy of your
			personal information.
			• to communicate with you and carry out your instructions and requests.
			• for customer satisfaction surveys, promotional offerings.
			• insurance and assurance underwriting and administration.
			• to process or consider or assess insurance or assurance claims.
			• to provide insurance and assurance policies and products and related services.
			• to enable you to take part in customer loyalty reward programmes, to determine your
			qualification for participation, earning of reward points, determining your rewards level, monitoring your buying behaviour with our rewards partners to allocate the correct points or inform you of appropriate products, goods, and services you may be interested in or to inform our reward partners about your purchasing behaviour.
			• to enable you to take part in and make use of value-added products and services.
			• to assess our lending and insurance risks; and / or
			• for any other related purposes.`,
			`How we use your personal information for marketing
			• We will use your personal information to our products and services to you.
			• We will do this in person, by post, telephone, or electronic channels such as
			SMS, email, and fax.
			• If you are not our customer, or in any other instances where the law requires, we will only market to you by electronic communications with your consent.
			• In all cases you can request us to stop sending marketing communications to you at any time.
			`,
			`When how and with whom we share your personal information?
			In general, we will only share your personal information if any one or more of the following apply:
			• if you have consented to this.
			• if it is necessary to conclude or perform under a contract, we have with you;
			• if the law requires it; and / or
			• if it’s necessary to protect or pursue your, our or a third party’s legitimate interest.
			Under what circumstances will we transfer your information to other countries?
			We will only transfer your personal information to third parties in another country in any one or more of the following circumstances:
			• where your personal information will be adequately protected under the other country’s laws or an agreement with the third-party recipient.
			• where the transfer is necessary to enter into or perform under a contract with you, or a contract with a third party that is in your interest.
			• where you have consented to the transfer; and / or
			• where it is not reasonably practical to obtain your consent, the transfer is in your
			interest.
			This transfer will happen within the requirements and safeguards of the law. Where possible, the party processing your personal information in the other country will agree to apply the
			same level of protection as available by law in your country or if the other country’s laws provide better protection the other country’s laws would be agreed to and applied.`,
			`How we secure your personal information
			• We will take appropriate and reasonable technical and organisational steps to protect your personal information according to industry best practices. Our security measures (including physical, technological, and procedural safeguards) will be appropriate and reasonable. This includes the following:
			• keeping our systems secure (like monitoring access and usage);
			• storing our records securely.
			• controlling the access to our buildings, systems and/or records; and
			• safely destroying or deleting records.
			• Ensure compliance with best practice standards.
			How long do we keep your personal information?
			We will keep your personal information for as long as:
			• the law requires us to keep it.
			• a contract between you and us requires us to keep it.
			• you have consented for us keeping it.
			• we are required to keep it to achieve the purposes listed in this Privacy Policy.
			• we require it for statistical or research purposes.
			• a code of conduct requires us to keep it; and / or
			• we require it for our lawful business purposes.
			Take note: We may keep your personal information even if you no longer have a relationship
			with us, for the historical data that may be required by your employer or employee.`,
			`Our cookie policy
			A cookie is a small piece of data sent from our websites or applications to your computer or device hard drive or Internet browser where it is saved. The cookie contains information to personalise your experience on our websites or applications and may improve your experience on the websites or applications. The cookie will also identify your device, like the computer or smart phone.
			By using our websites or applications you agree that cookies may be forwarded from the relevant website or application to your computer or device. The cookie will enable us to know that you have visited the website or application before and will identify you. We may also use the cookie to prevent fraud and for analytics.
			Your duties and rights about the personal information we have about you. You must provide proof of identity when enforcing the rights below.
			You must inform us when your personal information changes.
			Please contact our Information Officer to give effect to any of the below rights.
			You have the right to request access to the personal information we have about you by contacting us. This includes requesting:
			• confirmation that we hold your personal information.
			• a copy or description of the record containing your personal information; and
			• the identity or categories of third parties who have had access to your personal
			information.
			We will attend to requests for access to personal information within a reasonable time. You may be required to pay a reasonable fee to receive copies or descriptions of records, or information about third parties. We will inform you of the fee before attending to your request.
			Please note that the law may limit your right to access information.
			You have the right to request us to correct or delete the personal information we have about you if it is inaccurate, irrelevant, excessive, out of date, incomplete, misleading, obtained unlawfully or we are no longer authorised to keep it. You must inform us of your request in writing. It may take up to 15 business days for the change to reflect on our systems. We may request documents from you to verify the change in personal information.
			A specific agreement that you have entered into with us may determine how you must change your personal information provided at the time when you entered into the specific agreement. Please adhere to these requirements. If the law requires us to keep the personal information, it will not be deleted upon your request. The deletion of certain personal information may lead to the termination of your business relationship with us.
			You may object on reasonable grounds to the processing of your personal information.
			We will not be able to give effect to your objection if the processing of your personal information was and is permitted by law; you have provided consent to the processing and our processing done according to your consent or the processing is necessary to conclude or perform under a contract with you.
			Where you have provided your consent for the processing of your personal information, you may withdraw your consent. If you withdraw your consent, we will explain the consequences to you. We may proceed to process your personal information even if you have withdrawn your consent if the law permits or requires it. It may take up to 15 business days for the change to reflect on our systems, during this time we may still process your personal information. You must inform us of any objection in writing.
			You have a right to file a complaint with us or any Regulator with jurisdiction about an alleged contravention of the protection of your personal information by us. We will address your complaint as far as possible.
			The contact details for the Information Regulator is as follows:`,
			`Email:
			Postal Address: Physical Address:
			Complaints.IR@justice.gov.za
			P.O. Box 31533, Braamfontein, Johannesburg, 2017
			JD House, 27 Stiemens Street, Braamfontein, Johannesburg, 2001.
					 `,
			`How can you get in touch with us?
					 For any queries in relation to this letter or our processing of your persona information in general, you can contact our Information Officer and/or Deputy Information Officer at the following details:
					 Name: Tarryn Kim Gordon-Bennett
					 Contact Number: (+2711) 971-0800
					 Email Address: tarryn.gordonbennett@revlon.com
					 Physical Address: 28-30 Tungsten Road, Isando, 1600, South Africa`,
		];
		return (
			<View
				style={{
					flex: 1,
					flexDirection: "row",
					alignItems: "center",
				}}>
				<TouchableOpacity
					onPress={() => {
						this.setState({
							agreed: !this.state.agreed,
						});
						this.props.setParentState(!this.state.agreed);
					}}
					style={{
						marginRight: 5,
					}}>
					{this.state.agreed ? (
						<Image
							source={require("./../assets/images/checked.png")}
							style={{
								width: 16,
								height: 16,
								resizeMode: "contain",
							}}
						/>
					) : (
						<Image
							source={require("./../assets/images/unchecked.png")}
							style={{
								width: 16,
								height: 16,
								resizeMode: "contain",
							}}
						/>
					)}
				</TouchableOpacity>

				<TouchableOpacity
					style={{
						flexDirection: "row",
						alignItems: "center",
					}}
					onPress={() => {
						this.setState({
							showPolicy: true,
						});
					}}>
					<Text
						style={{
							alignItems: "center",
							justifyContent: "center",
							color: "#000",
							fontSize: 14,
						}}>
						<Font weight={300} family='Montserrat'>
							I agree to the terms and conditions of the
						</Font>
					</Text>
					<Text
						style={{
							alignItems: "center",
							justifyContent: "center",
							color: "#000",
							fontSize: 14,
						}}>
						<Font weight={600} family='Montserrat'>
							{" "}
							privacy policy
						</Font>
					</Text>
				</TouchableOpacity>

				<Modal
					transparent={true}
					visible={this.state.showPolicy}
					animationType='fade'
					shouldCloseOnOverlayClick={true}
					style={{
						width: w,
						height: h,
					}}>
					<View
						style={{
							width: w,
							height: h,
							justifyContent: "center",
							alignItems: "center",
						}}>
						<TouchableOpacity
							style={{
								width: w,
								height: h,
							}}
							onPress={() =>
								this.setState({
									showPolicy: false,
								})
							}>
							<View
								style={{
									// flex: 1,
									justifyContent: "center",
									alignItems: "center",
									backgroundColor: "rgba(52, 52, 52, 0.7)",
									width: w,
									height: h,
								}}></View>
						</TouchableOpacity>

						<View
							style={{
								position: "absolute",
								marginLeft: "auto",
								marginRight: "auto",
								width: w * 0.9,
								maxWidth: 450,
								// minHeight: 300,
								height: h,
								maxHeight: 600,
								// backgroundColor: "#E8E8E8",
								backgroundColor: "#FFF",
								borderRadius: 35,
								justifyContent: "center",
								alignItems: "center",
								padding: 18,
								paddingBottom: 0,
								shadowColor: "#000",
								shadowOffset: {
									width: 0,
									height: 2,
								},
								shadowOpacity: 0.25,
								shadowRadius: 7.84,
								elevation: 12,
								zIndex: 999,
							}}>
							<ScrollView
								contentContainerStyle={{
									paddingRight: 8,
								}}>
								<Text
									style={{
										marginBottom: 20,
										fontWeight: "500",
										fontSize: 20,
									}}></Text>
								<Text
									adjustsFontSizeToFit
									style={{
										color: "#000",
										fontSize: 17,
										margin: 10,
										marginBottom: 20,
									}}>
									<Font weight={500} family='Montserrat'>
										Privacy Policy
									</Font>
								</Text>

								{doc.map((d, i) => (
									<Fade>
										<View
											key={i}
											style={
												{
													// marginBottom: 10,
												}
											}>
											<Text
												style={{
													marginBottom: 10,
													fontWeight: "300",
													fontSize: 12,
												}}>
												{d}
											</Text>
										</View>
									</Fade>
								))}
								<Fade>
									<TouchableOpacity
										style={{
											width: "100%",
											marginBottom: 20,
											marginTop: 20,
										}}
										onPress={async () => {
											this.setState({
												showPolicy: false,
												agreed: true,
											});
											this.props.setParentState(true);
										}}>
										<View
											style={{
												backgroundColor: "#000",
												width: "100%",
												height: 45,
												borderRadius: 25,
												justifyContent: "center",
												alignItems: "center",
											}}>
											<Text
												style={{
													alignItems: "center",
													justifyContent: "center",
													color: "#FFF",
													fontSize: 15,
												}}>
												<Font weight={700} family='Montserrat'>
													Accept & Next
												</Font>
											</Text>
										</View>
									</TouchableOpacity>
								</Fade>
							</ScrollView>
						</View>
					</View>
				</Modal>
			</View>
		);
	}
}
